import { useReducedMotion } from 'framer-motion';
import { useOccConfig } from './use-occ-config';
/**
 * Returns the current [[OccAnimationConfig]] value.
 *
 * @remarks
 * Property enableAnimations will be overridden if the user's local
 * environment is configured for reduced motion.
 */
export const useAnimationConfig = () => {
    const shouldReduceMotion = useReducedMotion();
    const { animation } = useOccConfig();
    const enableAnimations = animation.enableAnimations && !shouldReduceMotion;
    return Object.assign(Object.assign({}, animation), { enableAnimations });
};
//# sourceMappingURL=use-animation-config.js.map